import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { getTemplateClusterlets } from '../../../store/constructs/templated_clusterlet/selectors';
import { deleteTemplateAndAssociates } from '../../../store/constructs/templated_clusterlet/actions';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import { setNodeClicked } from '../../../store/global/actions'
import { getAllTransactions } from '../../../store/constructs/transactions/selectors';
import { getEvents } from '../../../store/constructs/events/selectors';



export default function DeleteClusterletTemplates(props) {
    const { onCompletion, id, onClose } = props;

    const dispatch = useDispatch();

    const templatesInStore = useSelector(getTemplateClusterlets);
    const selectedTemplate = templatesInStore.find(template => template.id === id);
    const transactions = useSelector(getAllTransactions);
    const events = useSelector(getEvents);

    let trans = [];
    let associatedEvents = [];

    transactions.forEach(tra => {
        const foundClusterlet = tra.clusterlets.find(cl => cl.id == id);
        if (foundClusterlet) trans.push(tra)
    })

    events.forEach(ev => {
        const templateMessages = selectedTemplate?.metajson?.messages;
        Object.keys(templateMessages).forEach((msg) => {
            const foundEvent = events.find(event => event.message == templateMessages[msg]?.name && event?.messageFromTemplate);
            if (foundEvent) associatedEvents.push(associatedEvents);
        })

    })



    const onDelete = () => {
        dispatch(deleteTemplateAndAssociates(selectedTemplate));
        dispatch(setNodeClicked({}))
        onCompletion();
    }

    return (
        <Grid container direction={"row"} spacing={3} >
            <Grid item xs={12}>
                {trans.length > 0 && <Grid item xs={12}>
                    <Typography> {`This template is associated with the transaction  . Please delete that first.`}</Typography>
                </Grid>}
                {associatedEvents.length > 0 && <Grid item xs={12}>
                    <Typography> {`Message in this template is reused by some events  . Please delete that first.`}</Typography>
                </Grid>}
                {trans.length == 0 && associatedEvents.length == 0 && <Fragment>
                    <Typography> Are you sure you want to delete Template ?</Typography>
                </Fragment>}
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onDelete={onDelete} onCancel={onClose} disableButton={trans.length > 0 || associatedEvents.length > 0} />
            </Grid>
        </Grid >

    )

}